import { Flex } from "antd";
import ActionButtons from "./ActionButtons";
import NavigationButtons from "./NavigationButtons";

type EditFormFooterProps = {
  onCancel: () => void;
  onUpdate: () => void;
  onPrev: () => void;
  onNext: () => void;
  canGoPrev: boolean;
  canGoNext: boolean;
  isLoading?: boolean;
};

export default function EditFormFooter({
  onCancel,
  onUpdate,
  onPrev,
  onNext,
  canGoPrev,
  canGoNext,
  isLoading = false,
}: EditFormFooterProps) {
  return (
    <Flex align="center" justify="space-between" gap={20} wrap>
      <ActionButtons
        onCancel={onCancel}
        onUpdate={onUpdate}
        isLoading={isLoading}
      />

      <NavigationButtons
        onPrev={onPrev}
        onNext={onNext}
        canGoPrev={canGoPrev}
        canGoNext={canGoNext}
      />
    </Flex>
  );
}
